import { render, staticRenderFns } from "./ServiceNumberPrintContent.vue?vue&type=template&id=66b1ade1&scoped=true&"
import script from "./ServiceNumberPrintContent.vue?vue&type=script&lang=js&"
export * from "./ServiceNumberPrintContent.vue?vue&type=script&lang=js&"
import style0 from "./ServiceNumberPrintContent.vue?vue&type=style&index=0&id=66b1ade1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b1ade1",
  null
  
)

export default component.exports